import { createEvent } from './createEvent'

type ForecastPageViewedProperties = {
  fid: string
}

export const forecastPageViewed = createEvent<ForecastPageViewedProperties>(
  'Forecast Page Viewed',
)

type ForecastProperties = {
  fid: string
  modelId: string
}

export const forecastPageModelAdded = createEvent<ForecastProperties>(
  'Forecast Page Model Added',
)
export const forecastPageModelRemoved = createEvent<ForecastProperties>(
  'Forecast Page Model Removed',
)
